import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  details: {},
  id: null,
  isEdit:false,
};

const appDetailsSlice = createSlice({
  name: 'appDetails',
  initialState,

  reducers: {
    setAppDetails(state, action) {
      state.details = action.payload ?? {};
    },

    clearAppDetails(state) {
      state.details = {};
    },

    setId(state, action) {
      state.id = action.payload ;
    },

    setIsEdit(state, action) {
      // console.log('setIsEdit called with payload:', action.payload);
      state.isEdit = action.payload.data ;
      // console.log('isEdit state updated to:', state.isEdit);
    },

    clearId(state) {
      state.id = null;
    },
  },
});

export const {
  setAppDetails,
  clearAppDetails,
  // id,
  setId,
  setIsEdit,
  // isEdit,
  clearId,
} = appDetailsSlice.actions;

export default appDetailsSlice.reducer;